import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveDecizieInregistrare } from "@/api/endpoints/decizieInregistrare";
import { queryKeys } from "@/lib/queryClient";

export function useSaveDecizieInregistrare() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveDecizieInregistrare,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.decizieInregistrare.bySession(data.session_id),
      });
    },
  });
}
